module.exports = __webpack_public_path__ + "img/icn_logs.9a275912.svg";